import { render, staticRenderFns } from "./JingquKoubeiXiangxiPinglun.vue?vue&type=template&id=7847d39b&scoped=true&"
import script from "./JingquKoubeiXiangxiPinglun.vue?vue&type=script&lang=js&"
export * from "./JingquKoubeiXiangxiPinglun.vue?vue&type=script&lang=js&"
import style0 from "./JingquKoubeiXiangxiPinglun.vue?vue&type=style&index=0&id=7847d39b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7847d39b",
  null
  
)

export default component.exports